import { render, staticRenderFns } from "./ProjectRiskManagement.vue?vue&type=template&id=784badcc&scoped=true"
import script from "./ProjectRiskManagement.vue?vue&type=script&lang=js"
export * from "./ProjectRiskManagement.vue?vue&type=script&lang=js"
import style0 from "./ProjectRiskManagement.vue?vue&type=style&index=0&id=784badcc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784badcc",
  null
  
)

export default component.exports